import { useCallback } from 'react'

import useAppQueryState from '@hooks/useAppQueryState'

import { getAppConfig } from '@utils/getAppConfig'
import { getMarketingTrackingData } from '@utils/getMarketingTrackingData'
import { getSessionId } from '@utils/getSessionId'

import { getAlternativeProductApplicationUrl } from '../utils/getAlternativeProductApplicationUrl'

interface UseGetAlternativeProductApplicationUrlOptions {
    clickId: string
    productCode: string
}

type useGetAlternativeProductApplicationUrlReturn = (
    options: UseGetAlternativeProductApplicationUrlOptions
) => string

const useGetAlternativeProductApplicationUrl =
    (): useGetAlternativeProductApplicationUrlReturn => {
        const appConfig = getAppConfig()
        const { appQueryState } = useAppQueryState()
        const trackingData = getMarketingTrackingData(appQueryState)

        const memoizedGetAlternativeProductApplicationUrl = useCallback(
            ({
                productCode,
                clickId,
            }: UseGetAlternativeProductApplicationUrlOptions) => {
                return getAlternativeProductApplicationUrl({
                    clickSource: appConfig.CLICK_SOURCE_WHITELABEL,
                    productCode: productCode,
                    clickId,
                    visitGuid: getSessionId()!,
                    customerId: appQueryState.customerId!,
                    scoreId: appQueryState.scoreId!,
                    isKnownCustomer: appQueryState.isKnownCustomer!,

                    ...trackingData,
                })
            },
            [
                appQueryState.customerId,
                appQueryState.scoreId,
                appQueryState.isKnownCustomer,
                trackingData,
            ]
        )

        return memoizedGetAlternativeProductApplicationUrl
    }

export default useGetAlternativeProductApplicationUrl
